import { useState } from 'react'
import { OrgServerLimitCard } from './OrgServerLimitCard'
import { UserServerLimitCard } from './UserServerLimitCard'

export const ServerLimit = () => {
  const [orgServerLimit, setOrgServerLimit] = useState<number>(0)

  return (
    <div className="space-y-8" data-testid="server-limit-page">
      {/* Main Management Section */}
      <div
        className="bg-card border border-border rounded-xl overflow-hidden"
        data-testid="org-server-limit-section"
      >
        <div className="bg-muted/30 px-6 py-4 border-b border-border">
          <h3
            className="text-lg font-medium"
            data-testid="org-server-limit-heading"
          >
            Organization Server Limit
          </h3>
          <p className="text-sm text-muted-foreground">
            Set default server limits for all users
          </p>
        </div>
        <div className="p-6">
          <OrgServerLimitCard onLimitChange={setOrgServerLimit} />
        </div>
      </div>

      {/* User-specific server limit */}
      <div
        className="bg-card border border-border rounded-xl overflow-hidden"
        data-testid="user-server-limit-section"
      >
        <div className="bg-muted/30 px-6 py-4 border-b border-border">
          <h3
            className="text-lg font-medium"
            data-testid="user-server-limit-heading"
          >
            User-Specific Server Limits
          </h3>
          <p className="text-sm text-muted-foreground">
            Override default limits for specific users
          </p>
        </div>
        <div className="p-6">
          <UserServerLimitCard orgServerLimit={orgServerLimit} />
        </div>
      </div>
    </div>
  )
}
